/*
* deliverEmailModal
*/
export default class deliverEmailModal {
  attachEvent() {
    const titleText = document.getElementById('title-text');
    const contentText = document.getElementById('content-text');
    const sendButton = document.getElementById('send-button');
    let inputedTitle = false;
    let inputedContent = false;

    if (titleText) {
      titleText.addEventListener('keyup', (e) => {
        if (1 <= e.target.value.length) {
          inputedTitle = true;
        }
        if (inputedTitle && inputedContent) {
          sendButton.disabled = false;
        }
      });
    }
    if (contentText) {
      contentText.addEventListener('keyup', (e) => {
        if (1 <= e.target.value.length) {
          inputedContent = true;
        }
        if (inputedTitle && inputedContent) {
          sendButton.disabled = false;
        }
      });
    }
  }
}
